export default "__VITE_ASSET__B5ech0TZ__"